<template>
  <!--二级轮播-->
  <div>
    <el-carousel :autoplay="true" indicator-position="none">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <img :src="item.imgUrl" alt class="banerTwo"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
    import * as api from '../api/api.js'
    export default {
      name: "sec-carousel",
      data(){
          return{
            banner:[]
          }
      },
      created(){
        this.getBanerTwo()
      },
      methods:{
        getBanerTwo(){
          var Params ={
            igid:-1,
            key:'banner1'
          }
          api.getContent(Params).then(res =>{
            if(res.Status === 100){
              this.banner = JSON.parse(res.Data.Value)
            }else {
              this.$message({message: res.Msg,type: 'warning'})
            }
          })
        }
      }
    }
</script>

<style scoped>
  .banerTwo{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/secCarousel.vue